import dayjs from 'dayjs';
import { ArrowRotateRight } from 'iconsax-react';
import CheckReadIcon from '@/assets/images/icons/check-read.svg?react';
import CheckUnreadIcon from '@/assets/images/icons/check-unread.svg?react';
import useConversationStore, { useConversationHandlers } from '@/hooks/conversations/use-conversation-store';
import type { ConversationMessageTypeUnion } from '@/models/conversations/conversation';
import cn from '@/utils/merge-class-names';
import useMessageInfo from '../message-list-item/use-message-info';
import MessageDecoratorBurnTimer from './message-decorator-burn-timer';

interface Props {
  message: ConversationMessageTypeUnion;
}

export default function MessageDecoratorFooter({ message }: Props) {
  const { isMine, isStale, isGroup } = useMessageInfo(message);
  const { resetSelectedMessages } = useConversationStore();
  const { CreateTime, Status, IsRead } = message;
  const { handleInteraction } = useConversationHandlers();

  const handleRetry = () => {
    resetSelectedMessages([message]);
    handleInteraction('retry');
  };

  return (
    <div className='chat-footer text-metal-600'>
      <div className={cn('flex items-center gap-1', isMine ? 'justify-end' : 'justify-start')}>
        <span className='text-body3'>{dayjs(CreateTime).format('HH:mm')}</span>

        {Status === null ? (
          isStale ? (
            <button
              type='button'
              onClick={handleRetry}>
              <ArrowRotateRight className='size-3 cursor-pointer text-red-700' />
            </button>
          ) : (
            <span className='size-3 loading loading-spinner' />
          )
        ) : !isGroup && isMine ? (
          IsRead ? (
            <CheckReadIcon className='size-3' />
          ) : (
            <CheckUnreadIcon className='size-3' />
          )
        ) : null}

        <MessageDecoratorBurnTimer message={message} />
      </div>
    </div>
  );
}
